import { BaseDialog } from "./BaseDialog";
import useGameStore from "../../lib/store/GameStore";
import usePersistentStore from "../../lib/store/PersistentStore";
import { formatDate } from "../../lib/utils/locales";
import { useState } from "react";
import { useLocale, useT } from "../../i18n/LocaleContext";
import { localePath } from "../../i18n/config";

function GameHistoryDialog(props) {
  const t = useT();
  const [isOpen, setIsOpen] = useGameStore((state) => [
    state.isGameHistoryOpen,
    state.setIsGameHistoryOpen,
  ]);

  function closeModal() {
    setIsOpen(false);
  }

  return (
    <BaseDialog
      isOpen={isOpen}
      closeModal={closeModal}
      size="md"
      modalTitle={
        <div className="">
          <div className="text-center text-xl font-semibold dark:text-white">
            {t("history.title")}
          </div>
        </div>
      }
      modalBody={
        <div className="pt-2">
          <GameHistoryList />
        </div>
      }
    />
  );
}

export function GameHistoryList({ showGrids = null }) {
  const { locale, t } = useLocale();
  const [getLocalGridHistory] = usePersistentStore((state) => [
    state.getLocalGridHistory,
  ]);
  const [level] = useGameStore((state) => [state.levelNumber]);

  const [selectedLevel, setSelectedLevel] = useState(level);

  const showItems = showGrids || getLocalGridHistory();

  return (
    <div className="w-full space-y-1 text-center">
      {showItems.length == 0 && (
        <div className="my-1 px-4 py-4 text-left text-sm leading-snug sm:mx-0 sm:px-3 sm:py-2.5">
          <p className="mb-4">{t("history.allDone")}</p>
          <p>{t("history.checkBack")}</p>
        </div>
      )}
      {showItems.map((item) => (
        <a
          key={item.level}
          href={localePath(locale, `/${item.dateKey}`)}
          onClick={() => setSelectedLevel(item.level)}
          className={`${
            item.level === selectedLevel ? "bg-slate-100" : "hover:bg-slate-100"
          } mx-2 flex select-none items-center justify-between rounded-xl px-3 py-3.5 text-sm leading-snug sm:mx-0 sm:px-3 sm:py-2.5
            `}
        >
          <div className="flex items-center justify-start">
            <img
              className="h-5 w-5 sm:h-7 sm:w-7"
              src="/img/pokegrid-ball.png"
              alt={t("header.logoAlt")}
            />
            <span className="ml-2">#{item.level}</span>
            <span className="ml-2 text-xxs text-gray-700">•</span>
            <span className="ml-2">
              {formatDate(item.date, t("date.short"))}
            </span>
          </div>
          <div className="mr-2 flex items-center justify-center">
            {/* {item.attempt && item.attempt.guessesLeft == 0 && (
              <div
                className={`flex items-center justify-center
                text-gray-900`}
              >
                {item.attempt.score}/9
              </div>
            )} */}
            <div
              className={`ml-2 flex w-7 items-center justify-center
                text-gray-900`}
            >
              {item.level === selectedLevel && (
                <IconCheckO className="h-5 w-5 text-slate-500" />
              )}
            </div>
          </div>
        </a>
      ))}
    </div>
  );
}

function IconCheckO(props) {
  return (
    <svg fill="none" viewBox="0 0 24 24" height="1em" width="1em" {...props}>
      <path
        fill="currentColor"
        d="M10.243 16.314L6 12.07l1.414-1.414 2.829 2.828 5.656-5.657 1.415 1.415-7.071 7.07z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12zm11 9a9 9 0 110-18 9 9 0 010 18z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default GameHistoryDialog;
